import React, { useState } from "react";
import { Box } from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { MenuButton } from "../styled/CustomButtons";
import { ButtonSpinnerBlue } from "../styled/CustomSpinners";

export default function UpdateReceivedButton({ po_doc_id, addSnackbar, fetchPoDetails }) {
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const updateReceived = async () => {
    setLoadingUpdate(true);
    try {
      let response = await sendRequest(`purchase-orders/update-received?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingUpdate(false);
    }
  }

  return (
    <Box mt={2}>
      <MenuButton
        onClick={updateReceived}
        disabled={loadingUpdate}
      >
        {loadingUpdate ? <ButtonSpinnerBlue /> : "Refresh Received Qty"}
      </MenuButton>
    </Box>
  )
}